<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Pozabljeno geslo</h1>
        {{ recover_method }}
        <template v-if="recover_method && recover_method.type == 'SMS'">
            <empty-space/>
            <v-alert
                    v-if="invalid_confirmation_code"
                    type="error"
            >
                {{ invalid_confirmation_code }}
            </v-alert>
            <p class="text-md-center">Preko SMS sporočila smo vam poslali SMS potrditveno kodo. Vpišite jo za nadaljevanje postopka.</p>
            <v-form v-model="valid" @submit.prevent="" ref="form">
                <InputField v-model="confirmation_code" label="SMS potrditvena koda"></InputField>
            </v-form>
            <v-btn depressed large block color="primary_action" @click="checkSMSConfirm" :loading="loading_step1">NADALJUJ</v-btn>
        </template>
        <template v-if="!recover_method">
            <p class="text-md-center">Ste pozabili vaše geslo? Vpišite email naslov s katerim ste se registrirali v spletni profil.</p>
            <empty-space/>
            <v-alert
                    v-if="invalid_username_message"
                    type="error"
            >
                {{ invalid_username_message }}
            </v-alert>
            <empty-space v-if="invalid_username" />
            <v-form v-model="valid" @submit.prevent="" ref="form">
                <username-field v-model="email" required label="Vaš email naslov" v-on:keypress.enter="forgotPassword" autofocus />
            </v-form>
            <v-btn depressed large block color="primary_action" @click="forgotPassword" :loading="loading">PONASTAVI GESLO</v-btn>
        </template>
        <empty-space height="50px" />
        <split-content text="Potrebujete pomoč?"></split-content>
        <empty-space />
        <p v-if="application_type == 'HN'">
            Potrebujete pomoč? Pišite nam na <a href="mailto:info@hitrinakup.com">info@hitrinakup.com</a> in vam odgovorimo v najkrajšem možnem času.
        </p>
        <p v-if="application_type != 'HN'">
            Pokličite Center za pomoč uporabnikom na <b>080 13 10</b>, ali stopite z nami v stik preko <a target="_blank" href="https://www.tus.si/povejte-nam/">e-obrazca</a>.
        </p>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";
    import SplitContent from "../components/SplitContent";
    import UsernameField from "../components/UsernameField";
    import InputField from "../components/InputField";
    import {userService} from "../services";
    import Router from "../router";
    import Store from "../store";

    export default {
        name: "ForgotPassword",
        data: vm => ({
            loading_step1: false,
            valid: false,
            email: null,
            confirmation_code: null,
            invalid_confirmation_code: null
        }),
        components: {SplitContent, MainContentWrapper, EmptySpace, UsernameField, InputField},
        computed:{
            loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
            invalid_username: utils.vuexBuildSetGet(this, 'auth', 'invalid_username'),
            invalid_username_message: utils.vuexBuildSetGet(this, 'auth', 'invalid_username_message'),
            recover_method: utils.vuexBuildSetGet(this, 'auth', 'recover_method'),
            application_type: utils.vuexBuildSetGet(this, 'application', 'application_type')
        },
        mounted() {
            this.$trackPageVisit('forgot-password');
            this.$store.commit('auth/setRecoverMethod', null);
        },
        methods: {
            forgotPassword() {
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.$store.dispatch('auth/forgotPassword', {username: this.email});
                }
            },
            checkSMSConfirm(){
                this.loading_step1 = true;
                userService.forgotPasswordCheckCode(this.email, this.confirmation_code).then((data)=>{
                    this.$store.commit('auth/setRecoverPasswordUsername', this.email);
                    this.$store.commit('auth/setConfirmCode', this.confirmation_code);
                    this.$router.push('/novo-geslo/');
                }, (error)=>{
                    console.log(error);
                    this.invalid_confirmation_code = error.message;
                }).finally(()=>{
                    this.loading_step1 = false;
                });
            }
        }
    };

</script>

<style scoped>

</style>